import { supplierContactsListingStore } from './features/supplier-contacts-listing/supplier-contacts-listing.store';
import { supplierContactDetailsStore } from './features/supplier-contact-details/supplier-contact-details.store';

export const supplierContactsStore = {
  modules: {
    supplierContactsListingState: supplierContactsListingStore,
    supplierContactDetailsState: supplierContactDetailsStore
  }
};
